import { TranslateService } from "@ngx-translate/core";

import { DashboardItemType } from "../bfx-common/models/dashboard-item-type.enum";

import { BfxBlotterAction } from "shared/cubiq-services";

import {
  GoldenLayoutService,
  GLPopoutConfiguration,
  GLPopoutState,
  GLPopoutUndockBehaviour,
} from "../golden-layout/golden-layout-service";

import { GoldenLayoutAdditionMode } from "../golden-layout/golden-layout-addition-mode";
import { OrderDataImpl, PauseState } from "shared/cubiq-model-multi-asset";
import { BmarkOrderData } from "shared/cubiq-services/model/benchmarks/BmarkOrderData.model";

export class OrderPauseResumeInstruction {
  order: OrderDataImpl | BmarkOrderData;
}

export class OrderPauseResumeLaunchData {
  constructor(
    public action: BfxBlotterAction,
    public instructions: Array<OrderPauseResumeInstruction>,
  ) {}
}

export class BfxOrderPauseResumeComponentLauncher {
  /**
   * Launches a new instance of the order Pause/Resume window
   * @param orderIds ids of the orders to be paused or resumed
   * @param layoutService golden layout service instance
   * @param translationService ngx translation service instance
   */
  public static launch(
    action: BfxBlotterAction,
    instructions: Array<OrderPauseResumeInstruction>,
    layoutService: GoldenLayoutService,
    translationService: TranslateService,
  ): void {
    let title: string = "UNSET";
    if (action === BfxBlotterAction.ACTION_ORDER_PAUSE) {
      title = translationService.instant("pause.order.title");
    } else if (action === BfxBlotterAction.ACTION_ORDER_RESUME) {
      title = translationService.instant("resume.order.title");
    }

    let config: GLPopoutConfiguration = new GLPopoutConfiguration();

    config.initialState = GLPopoutState.POPOUT;
    config.undockBehaviour = GLPopoutUndockBehaviour.APPLY_BOUNDING_SIZE;
    config.popoutResizable = true;
    config.preferredSize = {
      width: Math.max(750, window.innerWidth / 2),
      height: 345,
    };
    config.minimumSize = { width: 630, height: 345 };
    config.data = new OrderPauseResumeLaunchData(action, instructions);

    layoutService.launchFromDashboard(
      title,
      DashboardItemType.OrderPauseResume,
      true,
      GoldenLayoutAdditionMode.DEFAULT,
      config,
    );
  }
}
